"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ALLOWED_SCHEDULED_EMAILS = void 0;
exports.MAX_ALLOWED_SCHEDULED_EMAILS = 50;
